import(/* webpackMode: "eager" */ "/vercel/path0/src/app/cookie-policy/page.tsx");
